module.exports = __webpack_public_path__ + "assets/repayment_success.svg";